const useCurrentTabObject = (tabs: {key: number; title: string}[], activeTab: number) => {
  return tabs.find(({key}) => key === activeTab)
}

export default useCurrentTabObject
